import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/lib/landingData";

export const Footer = () => {
  const navigate = useNavigate();

  const scrollTo = (id) => {
    if (window.location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer data-testid="footer" className="relative border-t border-white/10 py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 text-center">
          <img src={LOGO_URL} alt="b→come" className="h-16 w-auto" />
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
          <p className="font-display text-lg font-bold uppercase tracking-tight text-white">
            Dream. Plan. <span className="text-gradient">b&rarr;come.</span>
          </p>
          <p className="max-w-md text-sm text-muted-foreground">
            Your AI Life Coach for Becoming Your Best Self.
          </p>
          <nav className="mt-2 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm text-muted-foreground">
            <button onClick={() => navigate("/")} data-testid="footer-home"
              className="transition-colors hover:text-white">Home</button>
            <button onClick={() => scrollTo("how")} data-testid="footer-how"
              className="transition-colors hover:text-white">How it works</button>
            <button onClick={() => scrollTo("ai-academy")} data-testid="footer-academy"
              className="transition-colors hover:text-white">AI Academy</button>
            <button onClick={() => scrollTo("editions")} data-testid="footer-editions"
              className="transition-colors hover:text-white">Editions</button>
            <button onClick={() => navigate("/pricing")} data-testid="footer-pricing"
              className="font-semibold text-white transition-colors hover:text-[#F97316]">Pricing</button>
            <button onClick={() => scrollTo("start")} data-testid="footer-waitlist"
              className="transition-colors hover:text-white">Join waitlist</button>
          </nav>
          <nav className="mt-1 flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-xs text-muted-foreground">
            <button onClick={() => navigate("/privacy")} data-testid="footer-privacy"
              className="transition-colors hover:text-white">Privacy</button>
            <button onClick={() => navigate("/terms")} data-testid="footer-terms"
              className="transition-colors hover:text-white">Terms</button>
            <button onClick={() => navigate("/data-deletion")} data-testid="footer-data-deletion"
              className="transition-colors hover:text-white">Data deletion</button>
            <a href="mailto:hello@b-come.ai" data-testid="footer-contact"
              className="transition-colors hover:text-white">Contact</a>
          </nav>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-muted-foreground sm:flex-row">
          <span>© {new Date().getFullYear()} b→come. All rights reserved.</span>
          <span>Made for people chasing their dreams.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
